import React, { useContext, useEffect, useState } from 'react';
import { INSTANCE_WHITE_LOGO_URL as logo } from '../../components/ui/InstanceLogo';
import { SITE_URL } from '../../utils/appConfig';
import './terms.css'



const TermsPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [logoUrl, setLogoUrl] = useState<string | null>(null);



    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false)
        }, 1000);
    }, []);

    useEffect(() => {

        const company = process.env.REACT_APP_COMPANY;
        let url = logo;



        setLogoUrl(url);
    }, []);



    return (
        <div>
            {
                isLoading ?
                    (
                        <div className="d-flex justify-content-center">
                            <div className="spinner-border  text-info mt-5" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )
                    :
                    (

                        <div className={`wrapper ${isLoading ? 'fadeInDown' : ''} md-12`} >
                            <div id='header' className='headerLogin'>
                                <img src={logoUrl} alt='Logo' className='logo'></img>
                            </div>
                            <div id='termsContent' >
                                <h4 className='mb-2' style={{ textAlign: 'center' }}>T&Eacute;RMINOS Y CONDICIONES </h4>
                                <h4 className='mb-2' style={{ textAlign: 'center' }}>SWIFTPAY&reg;</h4>
                                {/* <article className="max-w-4xl mx-auto p-6 bg-white shadow rounded-lg text-gray-800"> */}
                                {/* <header className="mb-8">
                                        <h1 className="text-3xl font-bold mb-2">
                                            Términos y Condiciones — SWIFTPAY®
                                        </h1>
                                        <p className="text-sm text-gray-500">
                                            Vigencia: San José, Costa Rica – Octubre 2025<br />
                                            © SWIFTPAY S.A. – Todos los derechos reservados.
                                        </p>
                                    </header> */}

                                {/* Tabla de Contenido */}
                                {/* <nav className="mb-10">
                                    <h3 className="text-xl font-semibold mb-2">Índice</h3>
                                    <ol className="list-decimal ml-6 space-y-1">
                                        <li><a href="#descripcion">Descripción de la Plataforma</a></li>
                                        <li><a href="#uso">Condiciones de Uso</a></li>
                                        <li><a href="#pago">Condiciones de Pago y Liquidación</a></li>
                                        <li><a href="#reversiones">Reversiones, Reclamos y Contracargos</a></li>
                                        <li><a href="#obligaciones">Obligaciones del Usuario</a></li>
                                        <li><a href="#actividades">Actividades No Autorizadas y Prohibidas</a></li>
                                        <li><a href="#fraude">Prevención de Fraude y Monitoreo</a></li>
                                        <li><a href="#restricciones">Restricciones a la Afiliación</a></li>
                                        <li><a href="#terminacion">Terminación de la Afiliación</a></li>
                                        <li><a href="#indemnizacion">Indemnización</a></li>
                                        <li><a href="#responsabilidad">Responsabilidad del Contenido</a></li>
                                        <li><a href="#propiedad">Propiedad Intelectual</a></li>
                                        <li><a href="#cookies">Política de Cookies</a></li>
                                        <li><a href="#privacidad">Política de Privacidad</a></li>
                                    </ol>
                                </nav> */}

                                <section id="intro" className="space-y-4">
                                    <p style={{ marginTop: '5%', marginBottom: '8pt', }}>
                                        SWIFTPAY S.A., una sociedad costarricense inscrita en la Secci&oacute;n Mercantil del Registro P&uacute;blico bajo la c&eacute;dula jur&iacute;dica <strong>3-101-889631</strong>, con domicilio en <strong>San Jos&eacute;, Costa Rica</strong>, es titular de la marca <strong>SWIFTPAY&reg;</strong>, plataforma tecnol&oacute;gica que provee servicios de <strong>procesamiento de pagos electr&oacute;nicos, facturaci&oacute;n digital, links de pago, terminales POS, Tap on Phone, programas de lealtad, pagos recurrentes y otros servicios financieros digitales</strong>.
                                    </p>
                                    <p>
                                        Los USUARIOS o USUARIOS AFILIADOS son las personas físicas o jurídicas
                                        que contraten la afiliación y utilicen la plataforma de SWIFTPAY®.
                                    </p>
                                    <p>
                                        Si alguna cláusula fuese declarada ilegal, nula o inaplicable por
                                        autoridad competente, dicha disposición se tendrá por no puesta sin
                                        afectar la validez del resto del documento.
                                    </p>
                                </section>

                                {/* 1. Descripción */}
                                <section id="descripcion" className="mt-10 space-y-4">
                                    {/* <h3 className="text-2xl font-semibold">1. Descripción de la Plataforma SWIFTPAY®</h3> */}
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        1. Descripción de la Plataforma SWIFTPAY®
                                    </p>
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        1.1 API Framework
                                    </p>
                                    <p>
                                        Desarrollada por SWIFTPAY® para permitir el acceso a servicios de pago,
                                        conciliación, notificaciones, lealtad y otros. El USUARIO usará la API
                                        únicamente en las actividades autorizadas y conforme a la documentación
                                        técnica.
                                    </p>

                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        1.2 Pasarela / Orquestador de Autorización
                                    </p>
                                    <ul className="list-disc ml-6 space-y-1">
                                        <li>Recibir y validar solicitudes de pago.</li>
                                        <li>Mantener ciclo de vida de transacciones y conciliación.</li>
                                        <li>Registrar bitácora transaccional y eventos relevantes.</li>
                                        <li>Comunicar de forma segura (TLS, cifrado en tránsito).</li>
                                    </ul>


                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        1.3 Portal Web (Backoffice)
                                    </p>
                                    <ul className="list-disc ml-6 space-y-1">
                                        <li>Registro de reglas de negocio y antifraude.</li>
                                        <li>Administración de usuarios y afiliaciones.</li>
                                        <li>Reportes y gestión de pagos, links y POS.</li>
                                    </ul>


                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        1.4 Tipos de Transacciones
                                    </p>
                                    <ul className="list-disc ml-6 space-y-1">
                                        <li><b>Autorización y Captura:</b> autorización y débito en un solo paso.</li>
                                        <li><b>Pre-autorización:</b> retención temporal de fondos por hasta 5 días.</li>
                                        <li><b>Recurrencia:</b> cobros automáticos con autorización previa.</li>
                                    </ul>

                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        1.5 Modalidades de Servicio
                                    </p>
                                    <ul className="list-disc ml-6 space-y-1">
                                        <li><b>Facilitador de Pago (PayFac):</b> SWIFTPAY® afilia directamente al USUARIO.</li>
                                        <li><b>Integrador de Pago:</b> integración con cuenta adquirente existente.</li>
                                    </ul>
                                </section>

                                {/* 2. Uso */}
                                <section id="uso" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        2. Condiciones de Uso
                                    </p>
                                    <ul className="list-disc ml-6 space-y-1">
                                        <li>El USUARIO debe ser mayor de edad y suministrar información veraz.</li>
                                        <li>Las credenciales son confidenciales.</li>
                                        <li>Uso exclusivamente lícito; prohibidas actividades restringidas.</li>
                                        <li>No se permite acceso no autorizado o suplantación.</li>
                                        <li>El USUARIO es responsable de sus bienes y servicios vendidos.</li>
                                        <li>Debe mantener políticas de devoluciones visibles y actualizadas.</li>
                                    </ul>
                                </section>

                                {/* 3. Pago */}
                                <section id="pago" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        3. Condiciones de Pago y Liquidación
                                    </p>
                                    <p>
                                        Los precios y comisiones se pactan en el contrato de afiliación.
                                        SWIFTPAY® opera controles antifraude y liquida montos netos de comisiones
                                        y cargos aplicables por transferencia bancaria.
                                    </p>
                                    <ul className="list-disc ml-6 space-y-1">
                                        <li>Cuenta única a nombre del USUARIO.</li>
                                        <li>Liquidaciones según calendario contractual.</li>
                                        <li>SWIFTPAY® puede retener fondos para cubrir contracargos o gastos.</li>
                                    </ul>
                                </section>

                                {/* 4. Reversiones */}
                                <section id="reversiones" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        4. Reversiones, Reclamos y Contracargos
                                    </p>
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        4.1 Reversiones
                                    </p>
                                    <p>Gestionables por el USUARIO desde el Portal, hasta 60 días después.</p>


                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        4.2 Reclamos
                                    </p>
                                    <p>
                                        El titular puede objetar cargos ante su emisor. Penalidad por caso:
                                        US$75. El USUARIO dispone de 3 días hábiles para responder.
                                    </p>

                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        4.3 Contracargos
                                    </p>
                                    <p>
                                        Si la evidencia no es suficiente, el caso escala. El USUARIO dispone de 3
                                        días hábiles para aportar pruebas adicionales. Costos arbitrales a su
                                        cargo.
                                    </p>
                                </section>

                                {/* 5. Obligaciones */}
                                <section id="obligaciones" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        5. Obligaciones del Usuario
                                    </p>
                                    <ul className="list-disc ml-6 space-y-1">
                                        <li>Autoriza a SWIFTPAY® a recibir pagos en su nombre.</li>
                                        <li>Abstenerse de procesar operaciones sospechosas.</li>
                                        <li>No almacenar ni divulgar datos confidenciales de tarjetas.</li>
                                        <li>Verificar identidad y vigencia de medios de pago.</li>
                                        <li>Actualizar domicilios y giros comerciales.</li>
                                        <li>No utilizar la plataforma para pagos propios.</li>
                                    </ul>
                                </section>

                                {/* 6. Actividades */}
                                <section id="actividades" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        6. Actividades No Autorizadas y Prohibidas
                                    </p>
                                    <p><b>No Autorizadas:</b> vender bajo nombre distinto, transacciones por terceros, etc.</p>
                                    <p><b>Prohibidas:</b> pornografía, juegos de azar no autorizados, drogas, armas, criptoactivos sin licencia, etc.</p>
                                </section>

                                {/* 7. Fraude */}
                                <section id="fraude" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        7. Prevención de Fraude y Monitoreo
                                    </p>
                                    <p>
                                        SWIFTPAY® puede anular operaciones sospechosas, retener fondos y
                                        solicitar información adicional para validación.
                                    </p>
                                </section>

                                {/* 8. Restricciones */}
                                <section id="restricciones" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        8. Restricciones a la Afiliación
                                    </p>
                                    <ul className="list-disc ml-6 space-y-1">
                                        <li>Registros incompletos o no conformes.</li>
                                        <li>Altos índices de denegaciones o contracargos.</li>
                                        <li>Falta de pago de comisiones o cargos.</li>
                                    </ul>
                                </section>

                                {/* 9. Terminación */}
                                <section id="terminacion" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        9. Terminación de la Afiliación
                                    </p>
                                    <p>
                                        SWIFTPAY® podrá cancelar la afiliación ante incumplimientos o riesgo
                                        inaceptable. La terminación no exime al USUARIO de obligaciones
                                        pendientes.
                                    </p>
                                </section>

                                {/* 10. Indemnización */}
                                <section id="indemnizacion" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        10. Indemnización
                                    </p>
                                    <p>
                                        El USUARIO indemnizará a SWIFTPAY® por pérdidas, multas y honorarios
                                        derivados del uso indebido de la plataforma o violaciones legales.
                                    </p>
                                    <p>
                                        Límite de responsabilidad: 10% de tarifas pagadas en los últimos 12
                                        meses.
                                    </p>
                                </section>

                                {/* 11. Responsabilidad */}
                                <section id="responsabilidad" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        11. Responsabilidad del Contenido
                                    </p>
                                    <p>
                                        SWIFTPAY® no es responsable de la legalidad ni autenticidad de las
                                        transacciones del USUARIO, ni de fallas de terceros o lucro cesante.
                                    </p>
                                </section>

                                {/* 12. Propiedad */}
                                <section id="propiedad" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        12. Propiedad Intelectual
                                    </p>
                                    <p>
                                        Todo el software, diseño, contenidos e imágenes son propiedad de
                                        SWIFTPAY S.A. Se prohíbe su copia, modificación o ingeniería inversa sin
                                        autorización expresa.
                                    </p>
                                </section>

                                {/* 13. Cookies */}
                                <section id="cookies" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        13. Política de Cookies
                                    </p>
                                    <p>
                                        SWIFTPAY® utiliza cookies para mejorar la experiencia del usuario y
                                        seguridad. El USUARIO puede eliminarlas desde su navegador.
                                    </p>
                                </section>

                                {/* 14. Privacidad */}
                                <section id="privacidad" className="mt-10 space-y-4">
                                    <p style={{ marginTop: 0, marginBottom: '8pt', fontWeight: 'bold' }}>
                                        14. Política de Privacidad
                                    </p>
                                    <p>
                                        El tratamiento de datos personales se rige por la Política de Privacidad
                                        de SWIFTPAY®, disponible en{" "}
                                        <a
                                            href={`${SITE_URL}/privacy-policy`}
                                            className="text-blue-600 underline"
                                        >
                                            {SITE_URL}/privacy-policy
                                        </a>.
                                    </p>
                                    <p style={{ marginTop: '10%', marginBottom: '8%', textAlign: 'center' }}>
                                        <strong>Autorizada en San Jos&eacute;, Costa Rica &ndash; Octubre 2025.</strong><br />&copy; 2025 SWIFTPAY S.A. &ndash; Todos los derechos reservados.
                                    </p>
                                </section>
                                {/* </article> */}
                            </div>

                        </div>

                    )
            }

        </div>



    );
};




export default TermsPage;
